module.exports = __webpack_public_path__ + "static/media/white_logo.1525ffef.svg";